import { z } from "zod";

/** Canonical identity fields; scheduling display/distance information is a query projection. */
export const locationIdentitySchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
});
